import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useTranslation } from 'react-i18next';
import './UpgradeButton.css';

interface UpgradeButtonProps {
    className?: string;
    size?: 'small' | 'medium' | 'large';
    variant?: 'primary' | 'secondary' | 'outlined';
    showBenefits?: boolean;
}

const UpgradeButton: React.FC<UpgradeButtonProps> = ({ 
    className = '', 
    size = 'medium',
    variant = 'primary',
    showBenefits = true
}) => {
    const { user, isFree } = useAuth();
    const { t } = useTranslation();
    const navigate = useNavigate();

    // Only show for free users
    if (!isFree || !user) {
        return null;
    }

    const handleUpgrade = () => {
        // Navigate to benefits page to show full details before upgrading
        navigate('/benefits');
    };

    const buttonClasses = [
        'upgrade-button',
        `upgrade-button--${size}`,
        `upgrade-button--${variant}`,
        className
    ].filter(Boolean).join(' ');

    return (
        <div className="upgrade-button-container">
            <button 
                className={buttonClasses}
                onClick={handleUpgrade}
                title={t('upgrade.learnMore')}
            >
                <span className="upgrade-icon">⭐</span>
                {t('upgrade.upgradeToProTitle')}
            </button>
            
            {showBenefits && (
                <div className="upgrade-benefits">
                    <p className="upgrade-benefits-title">{t('upgrade.proBenefits')}</p>
                    <ul className="upgrade-benefits-list">
                        <li>✅ {t('upgrade.benefits.unlimitedSearches')}</li>
                        <li>✅ {t('upgrade.benefits.advancedAnalytics')}</li>
                        <li>✅ {t('upgrade.benefits.prioritySupport')}</li>
                        <li>✅ {t('upgrade.benefits.exportCapabilities')}</li>
                    </ul>
                </div>
            )}
        </div>
    );
};

export default UpgradeButton; 